module.exports = __webpack_public_path__ + "static/media/road-B-photo.035ce3cf.svg";